module.exports = __webpack_public_path__ + "img/unnervingPresence.153ffe2a.png";